import {
  RESET_AUTOMATIC_MESSAGES,
  RESET_AUTOMATIC_MESSAGE,
  RESET_ERROR,
  GET_AUTOMATIC_MESSAGES,
  SET_AUTOMATIC_MESSAGES,
  API_ERROR,
  GET_AUTOMATIC_MESSAGE,
  SET_AUTOMATIC_MESSAGE,
  CREATE_AUTOMATIC_MESSAGE,
  CREATE_AUTOMATIC_MESSAGE_SUCCESS,
  EDIT_AUTOMATIC_MESSAGE,
  EDIT_AUTOMATIC_MESSAGE_SUCCESS,
  DELETE_AUTOMATIC_MESSAGE,
  DELETE_AUTOMATIC_MESSAGE_SUCCESS,
} from "./actionTypes";

export const resetAutomaticMessages = () => {
  return {
    type: RESET_AUTOMATIC_MESSAGES,
    payload: {},
  };
};

export const resetAutomaticMessage = () => {
  return {
    type: RESET_AUTOMATIC_MESSAGE,
    payload: {},
  };
};

export const resetError = () => {
  return {
    type: RESET_ERROR,
    payload: {},
  };
};

export const getAutomaticMessages = (page, qnt, name) => {
  return {
    type: GET_AUTOMATIC_MESSAGES,
    payload: { page, qnt, name },
  };
};

export const setAutomaticMessages = (data, qtdDefault) => {
  const maxPage = Math.ceil(data.total / qtdDefault);
  var paging = Array.from({ length: maxPage }, (v, k) => k + 1);

  return {
    type: SET_AUTOMATIC_MESSAGES,
    payload: { ...data, paging },
  };
};

export const apiError = (error) => {
  return {
    type: API_ERROR,
    payload: error,
  };
};

export const createAutomaticMessage = (newAutomaticMessageValues) => {
  return {
    type: CREATE_AUTOMATIC_MESSAGE,
    payload: { newAutomaticMessageValues },
  };
};
export const createAutomaticMessageSuccess = (message) => {
  return {
    type: CREATE_AUTOMATIC_MESSAGE_SUCCESS,
    payload: { message },
  };
};

export const getAutomaticMessage = (idAutomaticMessage, isForm) => {
  return {
    type: GET_AUTOMATIC_MESSAGE,
    payload: { idAutomaticMessage, isForm },
  };
};
export const setAutomaticMessage = (data) => {
  return {
    type: SET_AUTOMATIC_MESSAGE,
    payload: { data },
  };
};

export const editAutomaticMessage = (idAutomaticMessage, newAutomaticMessageValues) => {
  return {
    type: EDIT_AUTOMATIC_MESSAGE,
    payload: { idAutomaticMessage, newAutomaticMessageValues },
  };
};
export const editAutomaticMessageSuccess = (message) => {
  return {
    type: EDIT_AUTOMATIC_MESSAGE_SUCCESS,
    payload: { message },
  };
};

export const deleteAutomaticMessage = (idAutomaticMessage) => {
  return {
    type: DELETE_AUTOMATIC_MESSAGE,
    payload: { idAutomaticMessage },
  };
};
export const deleteAutomaticMessageSuccess = (message) => {
  return {
    type: DELETE_AUTOMATIC_MESSAGE_SUCCESS,
    payload: { message },
  };
};
